import _                                              from 'underscore';
import moment, { Moment }                             from 'moment';
import React, { FC, useContext, useEffect, useState } from 'react';
import { Header, Icon, Label }                        from 'semantic-ui-react';
import { Cell, Grid }                                 from 'styled-css-grid';

import { Align }                             from '../../../../../types';
import { sumByAttribute }                    from '../../../../../util';
import { CONSTANTS }                         from '../../../../../constants';
import { ENTITY_ICONS }                      from '../../../../../constants/ProductEnums';
import { StyledContainer }                   from '../../../../containers';
import { DashboardProjectListItemContext }   from './ProjectListItem';
import { ProjectListItemActivitiesCalendar } from './ProjectListItemActivitiesCalendar';
import { ProjectListItemHiringCalendar }     from './ProjectListItemHiringCalendar';
import { useInView }                         from 'react-intersection-observer';

interface Props {
	fromDate?: Moment,
	monthCount?: number,
}

const defaultProps: Props = {
	fromDate:   moment(),
	monthCount: 4
}

export type GridColumnInfoType = [ startDate: Moment, endDate: Moment, dayCount: number ];

const ProjectListItemCalendar: FC<Props> = ( props ) => {
	
	let { monthCount, fromDate } = props,
	    { project }              = useContext( DashboardProjectListItemContext ),
	    { ref, inView }          = useInView( { triggerOnce: true } );
	
	useEffect( () => {
		
		if( inView ){
			
			// console.log( `${ project.name } is in view...` )
			
		}
		
	}, [ inView ] );
	
	const getStartOfMonthDate = ( monthOffset: number = 0 ) => {
		return fromDate.clone().add( monthOffset, 'months' ).startOf( 'month' )
	}
	
	const getEndOfMonthDate = ( monthOffset: number = 0 ) => {
		return fromDate.clone().add( monthOffset, 'months' ).endOf( 'month' )
	}
	
	let [ minDate, maxDate ] = [
		getStartOfMonthDate(),
		getEndOfMonthDate( monthCount - 1 ),
	];
	
	let gridColumns: GridColumnInfoType[] = _.range( 0, monthCount ).map( monthIndex => {
		
		let startTimeMarker = getStartOfMonthDate( monthIndex ),
		    endTimeMarker   = getEndOfMonthDate( monthIndex ),
		    dayCount        = startTimeMarker.daysInMonth();
		
		return [ startTimeMarker, endTimeMarker, dayCount ]
	} );
	
	let gridColumnCount = sumByAttribute( gridColumns, [ 2 ], 0 );
	
	let displayStartDate = ( minDate.year() === maxDate.year() )
	                       ? minDate.format( CONSTANTS.FORMATTING.DATES.MONTH_ABBR )
	                       : minDate.format( CONSTANTS.FORMATTING.DATES.MONTHYEAR_ABBR ),
	    displayEndDate   = maxDate.format( CONSTANTS.FORMATTING.DATES.MONTHYEAR_ABBR );
	
	return (
		<>
			<div ref={ ref }>
				
				<Grid columns={ 4 } rowGap={ `20px` }>
					
					<Cell width={ monthCount }>
						
						<Grid columns={ 2 }>
							<Cell middle>
								
								<Header as={ 'h5' } className={ 'no-margin' } color={ 'teal' }>
									<><Icon name={ ENTITY_ICONS.ACTIVITIES.ENTITY } color={ 'teal' }/> Upcoming Activities</>
								</Header>
							
							</Cell>
							<Cell middle>
								
								<StyledContainer textAlign={ Align.RIGHT } className={ 'no-margin padding-xs-bottom' }>
									
									<Label circular basic icon={ 'calendar alternate outline' } content={
										`${ displayStartDate } - ${ displayEndDate }`
									}/>
								
								</StyledContainer>
							
							</Cell>
						</Grid>
						
						{ inView && (
							
							<ProjectListItemActivitiesCalendar
								gridColumnCount={ gridColumnCount }
								gridColumns={ gridColumns }
							/>
						) }
					
					</Cell>
					<Cell width={ monthCount }>
						
						<Header as={ 'h5' } className={ 'no-margin' } color={ 'purple' }>
							<><Icon name={ ENTITY_ICONS.BUDGET.ENTITY_HIRING } color={ 'purple' }/> Scheduled Hiring</>
						</Header>
						
						{ inView && (
							
							<ProjectListItemHiringCalendar
								gridColumnCount={ gridColumnCount }
								gridColumns={ gridColumns }
							/>
						
						) }
					
					</Cell>
				</Grid>
			
			</div>
		</>
	);
};

ProjectListItemCalendar.defaultProps = defaultProps;

export { ProjectListItemCalendar }
